import React, { useEffect, useState } from 'react';

import ConfirmEmailCheckInbox from 'apps/auth/components/email/ConfirmEmailCheckInbox';
import ConfirmEmailPreview from 'apps/auth/components/email/ConfirmEmailPreview';
import BasePage from 'apps/auth/components/utils/BasePage';
import { useExtra } from 'apps/auth/hooks/selectors';

type ExtraState = {
    checkInbox?: boolean;
};

const ConfirmEmailPage = () => {
    const extra = useExtra<ExtraState>();
    const checkInbox = Boolean(extra?.checkInbox);
    const [showCheckInbox, setShowCheckInbox] = useState<boolean>(checkInbox);

    useEffect(() => {
        setShowCheckInbox(checkInbox);
    }, [checkInbox]);

    return showCheckInbox ? <ConfirmEmailCheckInbox /> : <ConfirmEmailPreview />;
};

export default BasePage(ConfirmEmailPage);
